import { CanvasImage, Img } from 'remotion';
import { withStillCorsCacheKey } from '@/lib/cover/withStillCorsCacheKey';
import { useHasVideoEffects, useVideoEffectDescriptors } from './VideoEffectsContext';
/** Lightweight duplicate footage posters use the same grade as the live source.
 *  Element type and src depend on the stable clip-level flag, so crossing a
 *  section boundary never swaps elements or reloads the image; only the
 *  per-frame stack changes (an empty stack is CanvasImage's default). */
export function EffectsImage({ src, style }: { src: string; style?: React.CSSProperties }) {
  const effects = useVideoEffectDescriptors();
  const hasEffects = useHasVideoEffects();
  return hasEffects ? <CanvasImage src={withStillCorsCacheKey(src)} effects={effects} fit="cover" style={style} /> : <Img src={src} style={style} />;
}
